export const Link = {
  baseStyle: {
    decoration: "none",
    color: "blue.500",
    _focus: {
      textDecoration: "underline",
      boxShadow: "none",
    },
  },
};
